/* Display amounts only. Never replace Shopify variant JSON or cart payload prices. */
window.SaleTagPricing = {
    percent(root) {
        const element = root?.jquery ? root[0] : root;
        const price = element?.matches('[data-sale-tag-percent]')
            ? element : element?.querySelector('[data-sale-tag-percent]');
        const percent = Number(price?.getAttribute('data-sale-tag-percent')) || 0;
        return Number.isInteger(percent) && percent > 0 && percent <= 100 ? percent : 0;
    },
    /* Variant rules (promo-variant:N:text tags): the same price element lists "variantId:percent"
       for every variant of the product. Null when the product has no rule, so callers fall back. */
    mapped(variant, root) {
        const element = root?.jquery ? root[0] : root;
        const price = element?.matches?.('[data-sale-tag-percent]')
            ? element : element?.querySelector?.('[data-sale-tag-percent]');
        const pairs = price?.getAttribute?.('data-sale-tag-variants');
        if (!variant || !pairs) return null;
        for (const pair of String(pairs).split(',')) {
            const [id, value] = pair.split(':');
            const percent = Number(value);
            if (value !== undefined && id === String(variant.id) && Number.isInteger(percent) && percent >= 0 && percent <= 100) {
                return percent;
            }
        }
        return null;
    },
    percentFor(variant, root) {
        return this.mapped(variant, root) ?? this.percent(root);
    },
    /* Trade buyers: the price element carries the tier factor (0.78 Dealer/PI, 0.88/0.85/0.80 Jobber)
       and the consumer promo percent. Their own price stays as is; the comparison becomes what a
       retail customer pays. Mirrors snippets/sale-tag-price.liquid. */
    trade(root) {
        const element = root?.jquery ? root[0] : root;
        const price = element?.matches?.('[data-trade-retail-factor]')
            ? element : element?.querySelector?.('[data-trade-retail-factor]');
        const factor = Number(price?.getAttribute('data-trade-retail-factor')) || 0;
        const promo = Number(price?.getAttribute('data-trade-promo')) || 0;
        return factor > 0 && factor < 1 ? { factor, promo } : null;
    },
    variant(variant, root) {
        if (!variant) return {};
        const trade = this.trade(root);
        if (trade) {
            if (!(variant.price > 0)) return { ...variant };
            let list = Math.round(variant.price / trade.factor);
            const rest = list % 100;
            if (rest === 1) list -= 1;
            else if (rest === 99) list += 1;
            const promo = this.mapped(variant, root) ?? trade.promo;
            const customer = promo > 0 ? list - Math.round(list * promo / 100) : list;
            return customer > variant.price ? { ...variant, compare_at_price: customer } : { ...variant };
        }
        const percent = this.percentFor(variant, root);
        if (!percent || variant.price <= 0) return { ...variant };
        return {
            ...variant,
            price: variant.price - Math.round(variant.price * percent / 100),
            compare_at_price: variant.price,
        };
    },
    sticky(root, variant, quantity) {
        const element = root?.jquery ? root[0] : root;
        if (!element || !variant) return;
        const display = this.variant(variant, element);
        const count = window.subtotal?.show ? Number(quantity) || 1 : 1;
        element.querySelectorAll('[data-sticky-add-to-cart] .sticky-price').forEach(price => {
            const hasCompare = display.compare_at_price > display.price;
            price.classList.toggle('has-compare-price', hasCompare);
            price.querySelectorAll('.money-compare-price').forEach(compare => compare.remove());
            if (hasCompare) {
                const compare = document.createElement('s');
                compare.className = 'money-compare-price';
                compare.dataset.comparePrice = display.compare_at_price;
                compare.innerHTML = Shopify.formatMoney(display.compare_at_price * count, window.money_format);
                price.prepend(compare);
            }
            const subtotal = price.querySelector('.money-subtotal');
            if (subtotal) subtotal.innerHTML = Shopify.formatMoney(display.price * count, window.money_format);
        });
    },
};
